import { Routes } from '@angular/router';
import {authGuard} from "./shared/auth/auth.guard";
import {authRedirectResolver} from "./shared/auth/auth-redirect-resolver";
import {AppPermissions} from "./shared/auth/app-permissions";
import {roleGuard} from "./shared/auth/role.guard";

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    resolve: {
      redirectTo: authRedirectResolver,
    },
    runGuardsAndResolvers: 'always',
    loadComponent: () => import('./layout/main-layout/main-layout.component').then(m => m.MainLayoutComponent),
    children: [
      {
        path: 'home',
        loadComponent: () => import('./pages/page-home/page-home.component').then(m => m.PageHomeComponent)
      },
      {
        path: 'saved-configurations',
        loadComponent: () => import('./pages/saved-configurations/saved-configurations.component').then(m => m.SavedConfigurationsComponent)
      },
      {
        path: 'detail-old/:modelId',
        loadComponent: () => import('./pages/page-model-detail-old/page-model-detail-old.component').then(m => m.PageModelDetailOldComponent)
      },
      {
        path: 'detail/:modelId',
        loadComponent: () => import('./pages/page-model-detail/page-model-detail.component').then(m => m.PageModelDetailComponent),
        children: [
          {
            path: 'report',
            children: []
          }
        ]
      },
      {
        path: 'reports-old/:modelId',
        loadComponent: () => import('./pages/page-model-report-old/page-model-report-old.component').then(m => m.PageModelReportOldComponent)
      },
      {
        path: 'reports/:modelId',
        redirectTo: 'detail/:modelId/report'
      },
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'admin',
    data: {
      roles: [AppPermissions.BACKOFFICE],
      titleTranslationKey: 'routes.main.company',
    },
    canActivate: [roleGuard],
    loadComponent: async () =>
        (await import('./layout/admin-layout/admin-layout.component'))
            .AdminLayoutComponent,
    children: [
      {
        path: 'models',
        loadComponent: () => import('./pages/admin/admin-page-models/admin-page-models.component').then(m => m.AdminPageModelsComponent)
      },
      {
        path: 'models/:modelId',
        loadComponent: () => import('./pages/admin/admin-page-model-detail/admin-page-model-detail.component').then(m => m.AdminPageModelDetailComponent)
      },
      {
        path: 'zones',
        loadComponent: () => import('./pages/admin/admin-page-zones/admin-page-zones.component').then(m => m.AdminPageZonesComponent)
      },
      {
        path: 'variables',
        loadComponent: () => import('./pages/admin/admin-page-variables/admin-page-variables.component').then(m => m.AdminPageVariablesComponent)
      },
	      {
        path: 'users/:subjectType/:subjectId',
        loadComponent: () => import('./pages/admin/admin-page-user-detail/admin-page-user-detail.component').then(m => m.AdminPageUserDetailComponent)
      },
	      {
	        path: 'users',
	        loadComponent: () => import('./pages/admin/admin-page-users/admin-page-users.component').then(m => m.AdminPageUsersComponent)
	      },
      {
        path: 'resources',
        loadComponent: () => import('./pages/admin/admin-page-resources/admin-page-resources.component').then(m => m.AdminPageResourcesComponent)
      },
	      {
	        path: 'policies',
	        loadComponent: () => import('./pages/admin/admin-page-policies/admin-page-policies.component').then(m => m.AdminPagePoliciesComponent)
	      },
	      {
	        path: '',
	        redirectTo: 'models',
        pathMatch: 'full'
      }
    ],
  },
  {
    path: '**',
    redirectTo: ''
  }
];
